module.exports = __webpack_public_path__ + "static/media/our-service-mobile-view.0b763350.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Partner/imgs/our-service-mobile-view.jpg
// module id = 1521
// module chunks = 0